export default __webpack_public_path__ + "static/media/home-search-travel.d9d38aa4.jpg";